import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import toast from 'react-hot-toast';
import { apiService } from '@/services/api';
import { useAuth } from '@/context/AuthContext';

const Container = styled.div`
  padding: 24px;
`;

const Card = styled.div`
  background: white;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
`;

const Title = styled.h2`
  margin: 0 0 12px 0;
`;

const Row = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
`;

const Input = styled.input`
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
`;

const Button = styled.button`
  padding: 10px 12px;
  border: none;
  border-radius: 6px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  cursor: pointer;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
  font-size: 14px;
`;

const Th = styled.th`
  text-align: left;
  padding: 8px;
  border-bottom: 1px solid #e5e7eb;
`;

const Td = styled.td`
  padding: 8px;
  border-bottom: 1px solid #f3f4f6;
`;

const AlterarPreco: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const [produtos, setProdutos] = useState<Array<{ Controle: number; Produto: string; Venda: number }>>([]);
  const [busca, setBusca] = useState('');
  const [controleSelecionado, setControleSelecionado] = useState<number | null>(null);
  const [novoPreco, setNovoPreco] = useState<string>('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) return;
    apiService.listarProdutosEstoque().then((rows) => setProdutos(rows)).catch(() => {});
  }, [isAuthenticated]);

  const filtrados = useMemo(() => produtos, [produtos]);

  const buscar = async () => {
    try {
      const rows = await apiService.listarProdutosEstoque(busca || undefined);
      setProdutos(rows);
    } catch (e: any) {
      toast.error(e?.message || 'Erro na busca');
    }
  };

  const handleSubmit = async () => {
    if (!controleSelecionado) {
      toast.error('Selecione um produto');
      return;
    }
    const parsed = Number(novoPreco.replace(',', '.'));
    if (!isFinite(parsed) || parsed <= 0) {
      toast.error('Informe um preço válido');
      return;
    }
    setLoading(true);
    try {
      await apiService.alterarPrecoTodas(controleSelecionado, parsed);
      toast.success('Preço atualizado para todas as filiais');
      setNovoPreco('');
    } catch (e: any) {
      toast.error(e?.message || 'Erro ao atualizar preço');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Card>
        <Title>Alterar Preço (todas as filiais)</Title>
        <Row>
          <Input placeholder="Buscar por nome ou controle" value={busca} onChange={(e) => setBusca(e.target.value)} />
          <Button onClick={buscar}>Buscar</Button>
          <Input placeholder="Controle selecionado" value={controleSelecionado ?? ''} readOnly />
          <Input placeholder="Novo preço" value={novoPreco} onChange={(e) => setNovoPreco(e.target.value)} />
          <Button onClick={handleSubmit} disabled={loading}>{loading ? 'Salvando...' : 'Salvar'}</Button>
        </Row>
        <Table>
          <thead>
            <tr>
              <Th>Controle</Th>
              <Th>Produto</Th>
              <Th>Venda atual</Th>
              <Th>Ação</Th>
            </tr>
          </thead>
          <tbody>
            {filtrados.map((p) => (
              <tr key={p.Controle}>
                <Td>{p.Controle}</Td>
                <Td>{p.Produto}</Td>
                <Td>{p.Venda}</Td>
                <Td>
                  <Button onClick={() => setControleSelecionado(p.Controle)}>Selecionar</Button>
                </Td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </Container>
  );
};

export default AlterarPreco;


